exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-pagination {\n  margin-top: 20px;\n  text-align: right;\n}\n.partner-manage-page .cell-content {\n  color: #008080;\n  cursor: pointer;\n  text-decoration: underline;\n  display: inline-block;\n  padding: 6px 10px;\n  line-height: 1.3em;\n}\n.bgImages_box {\n  list-style: none !important;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 0;\n}\n.bgImages_box li {\n    float: left;\n    margin-right: 5px;\n}\n.bgImages_box img {\n    display: inline-block;\n    height: 30px;\n    width: 48px;\n}\n", ""]);

// exports
